export default "__VITE_ASSET__MpAAiqLQ__"